import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";

const formatMetricScoreType = (metricType: string, score: number | undefined) => {
  if (isNaN(score as number)) {
    return;
  }

  switch (metricType) {
    case MetricEventTypes.CRITICAL_SCAN:
    case MetricEventTypes.SCAN_FREQUENCY:
      return Number(score?.toFixed(2));
    case MetricEventTypes.SCAN_TIMING:
      return Number(score!.toFixed(1));
    case MetricFilterTypes.GAMEPLAY_DURATION:
      if (score && score < 60) {
        return Number(score.toFixed(0));
      }

      return Number(((score || 0) / 60).toFixed(0));
    case MetricEventTypes.AWARENESS:
    case MetricEventTypes.DECISION:
    case MetricFilterTypes.BYB_IQ:
    default:
      return Number(score?.toFixed(0));
  }
};

export default formatMetricScoreType;
